import { render, staticRenderFns } from "./InviraUserShowData.vue?vue&type=template&id=19038eec"
import script from "./InviraUserShowData.vue?vue&type=script&lang=js"
export * from "./InviraUserShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports